var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuNotExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.0008V20.0008H3V18.0008H21ZM17.05 3.55078L22 8.50078L17.05 13.4508V3.55078ZM12 11.0008V13.0008H3V11.0008H12ZM12 4.00078V6.00078H3V4.00078H12Z",
    fill: "#343941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNotExtend);
export default __webpack_public_path__ + "static/media/icon_menu_not_extend.35f164b39a4ebac8691bf8f799826fb4.svg";
export { ForwardRef as ReactComponent };